import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '@/lib/analytics';

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const token = import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN;
    const environment = import.meta.env.VITE_ENVIRONMENT || 'development';

    if (token && token !== 'YOUR_MIXPANEL_PROJECT_TOKEN_HERE') {
      analytics.init({
        token,
        debug: environment === 'development' ? false : import.meta.env.VITE_ANALYTICS_DEBUG === 'true',
      });
    } else if (environment === 'production') {
      console.warn('⚠️ Mixpanel token not configured for production. Set VITE_MIXPANEL_PROJECT_TOKEN in your .env file to enable analytics.');
    }
  }, []);

  useEffect(() => {
    const pageName = getPageName(location.pathname);
    analytics.trackPageView(pageName, {
      path: location.pathname,
      search: location.search,
      hash: location.hash
    });
    // GA4 SPA page view (only fires if analytics_storage consent was granted)
    window.gtag?.('event', 'page_view', { page_path: location.pathname, page_title: pageName });
  }, [location]);

  const trackEvent = (eventName: string, properties?: Record<string, any>) => {
    analytics.track(eventName, properties);
  };

  const trackError = (error: Error, context?: Record<string, any>) => {
    analytics.trackError(error, context);
  };

  return { trackEvent, trackError };
};

const getPageName = (pathname: string): string => {
  const routes: Record<string, string> = {
    '/': 'Home',
    '/sobre': 'About',
    '/cursos': 'Courses',
    '/terapia': 'Therapy',
    '/contato': 'Contact',
  };

  return routes[pathname] || 'Unknown Page';
};
